<template>
  <p class="paragraph" :class="variantClass" v-html="cleanHTML"></p>
</template>

<script setup lang="ts">
interface IProps {
  content?: string;
  variant?: 'inverted' | 'default';
}

const props = withDefaults(defineProps<IProps>(), {
  content: undefined,
  variant: 'default',
});

const { clean } = useCleanHtml();

const cleanHTML = computed(() => {
  return clean(props.content, {
    stripNbsp: true,
    fixBrokenLinks: true,
    sanitize: true,
    externalLinks: true,
  });
});

const variantClass = computed(() => {
  return props.variant === 'inverted' ? 'paragraph--inverted' : '';
});
</script>

<style lang="postcss" scoped>
.paragraph {
  color: hsl(var(--color-primary-900));

  &.paragraph--inverted {
    color: hsl(var(--color-primary-50));
  }

  &:deep(a) {
    color: hsl(var(--color-secondary-500));
    font-weight: 500;
    text-decoration: underline;
    transition: color 150ms ease-in-out;

    @add-mixin hover {
      color: hsl(var(--color-secondary-700));
    }
  }
}
</style>
